import * as tslib_1 from "tslib";
import * as React from 'react';
import styled from 'styled-components';
import validProp from '@emotion/is-prop-valid';
var StyledIcon = React.forwardRef(function (props, ref) {
    var title = props.title, size = props.size, otherProps = tslib_1.__rest(props, ["title", "size"]);
    var iconProps = {
        viewBox: '0 0 24 24',
        height: props.height !== undefined ? props.height : size,
        width: props.width !== undefined ? props.width : size,
        // @ts-ignore - aria is not always defined on SVG in React TypeScript types
        'aria-hidden': title == null ? 'true' : undefined,
        focusable: 'false',
        role: title != null ? 'img' : undefined,
        "fill": "currentColor",
    };
    var svgProps = Object.keys(otherProps).reduce(function (p, k) {
        if (validProp(k)) {
            p[k] = otherProps[k];
        }
        return p;
    }, {});
    return (React.createElement("svg", tslib_1.__assign({}, iconProps, svgProps, { ref: ref }),
        title && React.createElement("title", { key: "SocialInstagramCircular-title" }, title),
        React.createElement("path", { d: "M12 3c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm0 7c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm2.8-2c0-.7.6-1.2 1.2-1.2s1.2.6 1.2 1.2-.5 1.2-1.2 1.2-1.2-.5-1.2-1.2zM12 19c-3.9 0-7-3.1-7-7h3c0 2.2 1.8 4 4 4s4-1.8 4-4h3c0 3.9-3.1 7-7 7z", key: "k0" })));
});
export var SocialInstagramCircular = styled(StyledIcon).withConfig({ displayName: "SocialInstagramCircular", componentId: "sc-1ljlu9g" })(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: inline-block;\n  vertical-align: middle;\n  overflow: hidden;\n"], ["\n  display: inline-block;\n  vertical-align: middle;\n  overflow: hidden;\n"])));
SocialInstagramCircular.displayName = 'SocialInstagramCircular';
export var SocialInstagramCircularDimensions = { height: 24, width: 24 };
var templateObject_1;
